import * as React from "react";
import { Button } from "react-bootstrap";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import WorksheetEditor from "../shared/WorksheetEditor";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface IProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class UnderwritingHub extends React.Component<IProps, any> {
  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <WorksheetEditor
          appId={app.id}
          loanFileWsId={app.loan_file_worksheet_id}
          openToWsName="UnderwritingSummary"
          showChildrenInline
          hideNavigation
        />

        <footer className={styles.footer}>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default UnderwritingHub;
